import {getImageSrc} from "@/js/images";

function setImgSrc(el, binding) {
    if (!(binding.oldValue === undefined || binding.value !== binding.oldValue)) {
        return;
    }
    getImageSrc(binding.value.url).then(function (src) {
        el.src = src;
    });
}
export default {
    install: function (Vue) {
        Vue.directive('auth-image', {
            bind: function (el, binding) {
                setImgSrc(el, binding);
            },
            componentUpdated: function (el, binding) {
                if (binding.oldValue.url !== binding.value.url) {
                    el.src = binding.value.url;
                }
            }
        });
    }
}